export const isReplicated = () => `
    query checkEntitiesVersion($entities: [Entity!]!) {
        checkEntitiesVersion(entities: $entities) {
            status
        }
    }
`;
